import React from "react";
import { Redirect, Route } from "react-router-dom";

import Nav from "../nav";
import Delivery from "./delivery";
import Inventory from "./inventory";
import Tables from "./tables";
import Tickets from "./tickets";
import Account from "./account";
import Sales from "./sales";
import ReportSchedules from "./reportSchedules";
import Rappi from "./rappi";
import Subscriptions from "./subscriptions";
import Pos from "./pos";
import { has_access } from "../../../../middleware/privileges";
import { User } from "../../../../models/user_model";

const Pref: React.FC = () => {
  const canEditInfo = has_access(128); // edit_info
  const userData: User = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = has_access(1) && !userData.subuser_id;

  const main_nav = [
    ...(canEditInfo
      ? [
          { name: { es: "Cuenta", en: "Overview" }, link: "/settings/account" },
          {
            name: { es: "Punto de Venta", en: "POS" },
            link: "/settings/pos",
          },
          {
            name: { es: "Envíos a Domicilio", en: "Delivery" },
            link: "/settings/delivery",
          },
          {
            name: { es: "Mesas", en: "Tables" },
            link: "/settings/tables",
          },
          {
            name: { es: "Inventario", en: "Inventory" },
            link: "/settings/inventory",
          },
        ]
      : []),
    {
      name: { es: "Tickets", en: "Tickets" },
      link: "/settings/tickets",
    },
    ...(canEditInfo
      ? [
          {
            name: { es: "Ventas", en: "Sales" },
            link: "/settings/sales",
          },
          {
            name: { es: "Reportes", en: "Reports" },
            link: "/settings/report-schedules",
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            name: { es: "Suscripciones", en: "Subscriptions" },
            link: "/settings/subscriptions",
          },
        ]
      : []),
    // {
    //   name: { es: "Rappi", en: "Rappi" },
    //   link: "/settings/rappi",
    // },
  ];

  return (
    <div className="pref_section">
      <Nav items={main_nav} />
      <Route path="/account/settings" exact={true}>
        <Redirect
          to={
            canEditInfo
              ? "/account/settings/account"
              : "/account/settings/tickets"
          }
        />
      </Route>
      <Route path="/account/settings/tickets" component={Tickets} />
      {canEditInfo && (
        <>
          <Route path="/account/settings/pos" component={Pos} />
          <Route path="/account/settings/delivery" component={Delivery} />
          <Route path="/account/settings/tables" component={Tables} />
          <Route path="/account/settings/inventory" component={Inventory} />
          <Route path="/account/settings/account" component={Account} />
          <Route path="/account/settings/sales" component={Sales} />
          <Route
            path="/account/settings/report-schedules"
            component={ReportSchedules}
          />
          <Route path="/account/settings/rappi" component={Rappi} />
        </>
      )}
      {isAdmin && (
        <Route
          path="/account/settings/subscriptions"
          component={Subscriptions}
        />
      )}
    </div>
  );
};

export default Pref;
